import styled from 'styled-components';

import {StyledSettingsContent, StyledSettingsMain} from '../../common/settingsWrapper';
import {settingsHorizontalSpacing} from '../../settingsCommonConstants';

export const StyledEditorMain = styled(StyledSettingsMain)`
  justify-content: space-between;
`;

export const StyledEditorWrapper = styled(StyledSettingsContent)`
  padding-left: ${settingsHorizontalSpacing}px;

  max-width: 530px;

  & > *:not(:last-child) {
    margin-bottom: 40px;
  }
`;
